export default __webpack_public_path__ + "static/media/courier.91167f10.svg";